// AdminCreatePlayer — legacy URL adapter.
//
// Phase 13: the create-player flow now lives in CreatePlayerModal,
// triggered from the Players list. This page exists only to keep the
// old routes working — it auto-opens the same modal:
//
//   /people/agents/:id/players/new  → modal pre-selects that agent
//   /people/players/new             → modal with empty agent picker
//
// On close, route back to whichever list is most useful.

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CreatePlayerModal from '@baaligames/shared-ui/admin/components/CreatePlayerModal';

export default function AdminCreatePlayer() {
  const { id } = useParams<{ id: string }>();
  const initialAgentId = id ? Number(id) : undefined;
  const nav = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!open) {
      nav(initialAgentId ? `/people/agents/${initialAgentId}` : '/people/players',
          { replace: true });
    }
  }, [open, initialAgentId, nav]);

  return (
    <CreatePlayerModal
      mode="admin"
      initialAgentId={initialAgentId}
      onClose={() => setOpen(false)}
      onCreated={() => setOpen(false)}
    />
  );
}
